module.exports = __webpack_public_path__ + "img/ic_circle.28661e7e.svg";